import service from '../service.js'

export default {
    getSection(){
      return service.get('section')
    },
    addSection(div_code, dep_code, section, abbr, rc_code, status){
        return service.post('section',{
            div_code    : div_code,
            dep_code    : dep_code,
            section     : section,
            abbr        : abbr,
            rc_code     : rc_code,
            status      : status
        })
    },
    editSection(sec_code, div_code, dep_code, section, abbr, rc_code, status){
        return service.put('section',{
            sec_code    : sec_code,
            div_code    : div_code,
            dep_code    : dep_code,
            section     : section,
            abbr        : abbr,
            rc_code     : rc_code,
            status      : status
        })
    },
}